export default {
  title: 'Fecha y hora',
  buttons: {
    done: 'Listo',
  },
};
